export type GeoErrorStatus = 'OUTSIDE_RADIUS' | 'NO_LOCATION' | 'NO_GEOFENCE_CONFIGURED';

export interface GeoLocation {
  latitude: number;
  longitude: number;
  accuracy_meters?: number;
  captured_at: string;
}

export interface TimeEntry {
  id: string;
  clock_in: string;
  clock_out: string | null;
  ip_address_in: string | null;
  ip_address_out: string | null;
  profile_id: string;
  company_id: string;
  geo_status?: string | null;
  attendance_flags?: Array<{
    id: string;
    flag_type: string;
    flag_severity: string;
    flag_reason: string | null;
    event_date: string;
    event_time: string | null;
  }>;
}

export interface ClockInRequest {
  profile_id: string;
  company_id: string;
  ip_address_in: string | null;
  geo_location?: GeoLocation;
}

export interface ClockOutRequest {
  entry_id: string;
  ip_address_out: string | null;
  geo_location?: GeoLocation;
}

export interface CurrentTimeEntryResponse {
  entry: TimeEntry | null;
  isLoggedIn: boolean;
}

export class GeolocationError extends Error {
  constructor(
    message: string,
    public geoStatus?: string,
    public distance?: number,
    public allowedRadius?: number,
    public locationName?: string,
    public locationAddress?: string,
    public flagReason?: string
  ) {
    super(message);
    this.name = 'GeolocationError';
  }
}
